export const getPathname = () => {
  return window.location.pathname
}

export const isLocationMatched = (url, identifier) => {
  const identifierInRegex =
    typeof identifier === 'string' ? new RegExp(identifier) : identifier

  return identifierInRegex.test(url)
}
